
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vdkpj_4tozc_181",
  "item-wrapper": "awsui_item-wrapper_vdkpj_4tozc_217",
  "group": "awsui_group_vdkpj_4tozc_221",
  "divider": "awsui_divider_vdkpj_4tozc_225"
};
  